module.exports = __webpack_public_path__ + "static/header-9aa3da465c24ae4f6275159f318c3ecc.jpg";